import React, { useEffect, useState } from "react";
import { BrowserViewContext, BrowserViewItem } from "./utils";
import WebView from "./Webview";
import { changeEgovUrl } from "@/utils/tools";
import ThirdAppContainer from "../ThirdApp/components/ThirdAppContainer";
import NewThirdappAnalysis from "../ThirdApp/components/NewThirdappAnalysis";
import { FocusSDK } from "@/utils";
import Axios from "axios";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";

export default function BrowserViewBody({ style }: { style?: any }) {
  const { items, selectedId, defaultPage, thirdAppListAll } = React.useContext(BrowserViewContext);
  const [pdfOpenAppKeyArray, setPdfOpenAppKeyArray] = useState<any>(["2qgWfnAPe4jViv53CKqo"]);
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);

  const startupBody = defaultPage ? <div className="default-page">{defaultPage.body}</div> : null;

  // useEffect(() => {
  //   const fn = async () => {
  //     try {
  //       const configHost = FocusSDK.isPrivateNet()
  //         ? "https://jzb.beijing.egov.cn/oss/focus-desktop"
  //         : "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com";
  //       const { data, status } = await Axios.get(
  //         `${configHost}/config/${appRuntimeEnv.envConfig.key}/thirdApp-config.json?d=${Date.now()}`
  //       );
  //       if (status === 200) {
  //         const { pdfOpen } = data;
  //         if (Array.isArray(pdfOpen)) {
  //           setPdfOpenAppKeyArray(pdfOpen);
  //         }
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   fn();
  // }, []);
  return (
    <div
      style={{
        position: "relative",
        flex: 1,
        backgroundColor: "#fff",
        display: "flex",
        ...style
      }}
    >
      {startupBody}
      {items.map((item: BrowserViewItem) => {
        if (item.isNewThirdappAnalysis) {
          return item.id === selectedId ? <NewThirdappAnalysis /> : "";
        } else {
          return item.isApplications ? (
            // <div>this is applications</div>
            item.id === selectedId ? (
              <ThirdAppContainer
                isApplications={item.isApplications}
                cards={{}}
                groups={thirdAppListAll}
              />
            ) : (
              ""
            )
          ) : (
            <WebView
              key={item.id}
              visible={item.id === selectedId}
              item={item}
              src={changeEgovUrl(item.link)}
              resetPartition={pdfOpenAppKeyArray.includes(item.appKey) ? true : false}
              withToolbar={true}
            />
          );
        }
      })}
    </div>
  );
}
